import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ShortcutIcon from '@mui/icons-material/Shortcut';

import {
  Avatar,
  Box,
  CircularProgress,
  Divider,
  Grid,
  MenuItem,
  Paper,
} from '@mui/material';

import {
  Button,
  DatePicker,
  Dt,
  Editor,
  FileUpload,
  ImagePicker,
  Page,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { Bug } from '../../../models/Bug';
import { User } from '../../../models/User';
// import { User } from '../../../models/User';

// import HelpersPractice from '../../../actions/helpers/practice';

const { DateTime } = require("luxon");

type Props = {}

export const AdminBugEdit: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();
  const queryClient = useQueryClient();
  
  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [msg, setMsg] = useState<string>('');
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [mainObject, setMainObject] = useState<Bug>({
    title: ''
  });
  const [copiedMainObject, setCopiedMainObject] = useState<Bug>({
    title: ''
  });
  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [clientSearch, setClientSearch] = useState<string>('');

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["bug", objectId],
    queryFn: () =>
      fetch_one<Bug>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'bug',
          id: objectId,
          fields: [
            'id', 'title', 'status', 'created_at', 'updated_at', 'content', 'bug_type', 'impact', 'internal_impact', 
            'get_item', 'item_file_name', 'practice_id', 'user_id', 'owner_id', 'ping_owner', 'ping_user', 'extra_data', 'practice|id/name', 'owner|id/full_name',
            'owner', 'other_bug_count', 'search_terms', 'internal_comment'
          ],
          sub_fields: {
            owner: ['id', 'full_name', 'get_medium', 'practice', 'type'],
            practice: ['id', 'name']
          }
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     published_at: DateTime.fromISO(d.published_at).toFormat("dd/LL/y"),
    //     // end_time: DateTime.fromISO(d.end_time).toFormat("dd/LL/y t"),
    //     // background_colour: d.background_colour || 'rgb(211, 211, 211)'
    //   };
    // },
    enabled: login?.type === "User::Admin" && parseInt(objectId || '', 10) > 0,
  });

  const {
    data: clients,
    isLoading: clientsLoading,
    isError: clientsError,
    isSuccess: clientsSuccess,
    // refetch: clientsRefetch,
  } = useQuery({
    queryKey: ["clients", "with_email", currentPractice?.id, clientSearch],
    queryFn: () =>
      fetch_all<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          fields: ['id', 'full_name', 'last_login_date', 'language_id', 'email', 'consent_status'],
          order: "first_name ASC, last_name ASC",
          filter: {
            search: clientSearch,
            advanced: {
              // for_practice: (login?.practice_id || currentPractice?.id),
              // ignore_closure: 1
              // enabled: '1'
            }
          },
          // practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    // enabled: !!currentPractice?.id
  });








  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<Bug>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setMsg('');
      setTimeout(() => {setFlickerEditor(false);}, 200);
      objectRefetch();
    },
  });
  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      keepOpen?: boolean
    }) => {
      return fetch_one<Bug>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSavedOpen(true);
      queryClient.invalidateQueries({ queryKey: ["admin", "bugs", (login?.practice_id || currentPractice?.id)] });
      queryClient.invalidateQueries({ queryKey: ["bug", data.id] });
      if (!variables.keepOpen) navigate("/bugs");
      if (!!variables.keepOpen && objectId === 'new') navigate(`/bug/${data.id}`);
      if (!!variables.keepOpen && objectId !== 'new') objectRefetch();
    },
  });








  const checkEqual = (ob1:Bug, ob2:Bug) => {
    return (
      ob1.title === ob2.title &&
      ob1.content === ob2.content &&
      ob1.internal_comment === ob2.internal_comment &&
      ob1.search_terms === ob2.search_terms &&
      ob1.bug_type === ob2.bug_type &&
      ob1.impact === ob2.impact &&
      ob1.internal_impact === ob2.internal_impact &&
      ob1.practice_id === ob2.practice_id &&
      ob1.owner_id === ob2.owner_id &&
      ob1.user_id === ob2.user_id &&
      ob1.status === ob2.status &&
      ob1.item === ob2.item
    );
  };





  
  let termSingle = t("admin.models.bug.singular");

  let page_title;
  if (typeof((object || {}).id) === 'undefined') {
    page_title = (mainObject || {}).title || termSingle.toLowerCase();
  } else {
    page_title = t("general.titles.edit", "Wijzig") + " " + (object || {}).title;
  }

  useEffect(() => {
    if (!!objectSuccess) {
      setMainObject(object);
      setCopiedMainObject(object);
    }
  }, [object]);
  useEffect(() => {
    setObjectId(params.id);
  }, [params.id]);

  return <Page
    title={page_title}
    titleCrumbs={[
      {
        title: t("admin.menu.tickets"),
        path: "/bugs"
      }
    ]}
  >
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">{t("general.bugs.section.reporter")}</Typography>
        <Divider />
      </Grid>
      {!!mainObject?.owner && <Grid item xs={12} md={4}>
        <Box sx={{
          padding: 2,
          background: 'white',
          border: '1px solid transparent',
          borderColor: theme.palette.primary.main,
          borderRadius: 1,
          textAlign: 'center'
        }}>
          <Avatar sx={{width: '98px', height: '98px', marginLeft: 'auto', marginRight: 'auto'}} src={mainObject.owner?.get_medium}></Avatar>
          <Typography>{mainObject.owner?.full_name}</Typography>
          <Typography sx={{fontSize: '0.8rem', fontStyle: 'italic'}}>{mainObject.owner?.type}</Typography>
          <Typography sx={{fontStyle: 'italic', fontSize: '0.9rem'}}>{mainObject.owner?.practice?.name}</Typography>
        </Box>
      </Grid>}
      {!!mainObject?.owner && <Grid item xs={12} md={8}>
        <Box sx={{
          padding: 2,
          background: 'white',
          border: '1px solid transparent',
          borderColor: theme.palette.primary.main,
          borderRadius: 1,
          textAlign: 'left'
        }}>
          <Typography sx={{textDecoration: 'underline'}}>Report time:</Typography>
          <Typography sx={{paddingLeft: 2}}><Dt d={mainObject?.created_at} f="dd/LL/y t" /></Typography>
          <Typography sx={{textDecoration: 'underline'}}>Last change:</Typography>
          <Typography sx={{paddingLeft: 2}}><Dt d={mainObject?.updated_at} f="dd/LL/y t" /></Typography>
          <Typography sx={{textDecoration: 'underline'}}>Other reports:</Typography>
          <Typography sx={{paddingLeft: 2}}>{mainObject?.other_bug_count || 0}</Typography>
        </Box>
      </Grid>}
      {!mainObject?.id && <>
        <Grid item xs={12} md={6}>
          <TextInput
            id="client_search"
            caption="Owner"
            value={clientSearch}
            backend
            onChange={(e) => {
              setClientSearch(e);
            }}
          />
          <Typography sx={{fontSize: '0.7rem', fontStyle: 'italic', marginBottom: 1}}>{(clients || []).length} {t("general.results_found")}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            fullWidth
            caption={t("coach.models.appointments.client", "Client")}
            starred
            backend
            displayEmpty
            id="user_id"
            value={mainObject.owner_id || ''}
            setValue={(v) => {
              setMainObject({
                ...mainObject,
                owner_id: !!v ? parseInt(v.toString(), 10) : undefined
              });
            }}
          >
            <MenuItem value="">------</MenuItem>
            {(clients || []).map(client => <MenuItem
              disabled={!!client.consent_status?.is_blocked}
              value={client.id}
              sx={{
                ...(!!client.consent_status?.is_blocked ? {
                  color: 'grey',
                  textDecoration: 'line-through'
                } : {})
              }}
            >{client.full_name}&nbsp;<span style={{fontSize: '0.8rem', marginLeft: 1}}>({client.email})</span></MenuItem>)}
          </Select>
        </Grid>
      </>}
      <Grid item xs={12}>
        <Typography variant="h5">{t("general.bugs.section.basic")}</Typography>
        <Divider />
      </Grid>
      <Grid item xs={12} md={4}>
        <Select
          fullWidth
          caption={t("general.bugs.fields.bug_type")}
          starred
          backend
          displayEmpty
          id="bug_type"
          value={mainObject.bug_type?.toString() || '0'}
          setValue={(v) => {
            setMainObject({
              ...mainObject,
              bug_type: !!v ? parseInt(v.toString(), 10) : undefined
            });
          }}
        >
          <MenuItem value="0">{t("general.bugs.fields.bug_types.bug", "Bug")}</MenuItem>
          <MenuItem value="1">{t("general.bugs.fields.bug_types.feature", "Feature")}</MenuItem>
          <MenuItem value="2">{t("general.bugs.fields.bug_types.question", "Question")}</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={12} md={4}>
        {mainObject.bug_type === 0 && <Select
          fullWidth
          caption={t("general.bugs.fields.impact")}
          backend
          displayEmpty
          id="impact"
          value={mainObject.impact?.toString() || '0'}
          setValue={(v) => {
            setMainObject({
              ...mainObject,
              impact: !!v ? parseInt(v.toString(), 10) : undefined
            });
          }}
        >
          <MenuItem value="0">{t("general.bugs.fields.impacts.none", "Geen impact")}</MenuItem>
          <MenuItem value="1">{t("general.bugs.fields.impacts.small", "Weinig impact (workaround beschikbaar)")}</MenuItem>
          <MenuItem value="2">{t("general.bugs.fields.impacts.much", "Veel impact (geen workaround, maar ik kan verder)")}</MenuItem>
          <MenuItem value="3">{t("general.bugs.fields.impacts.breaking", "Brekend (ik kan niet verder)")}</MenuItem>
        </Select>}
      </Grid>
      <Grid item xs={12} md={4}>
        {mainObject.bug_type === 0 && <Select
          fullWidth
          caption={t("general.bugs.fields.internal_impact")}
          backend
          displayEmpty
          id="internal_impact"
          value={mainObject.internal_impact?.toString() || '0'}
          setValue={(v) => {
            setMainObject({
              ...mainObject,
              internal_impact: !!v ? parseInt(v.toString(), 10) : undefined
            });
          }}
        >
          <MenuItem value="0">{t("general.bugs.fields.impacts.none", "Geen impact")}</MenuItem>
          <MenuItem value="1">{t("general.bugs.fields.impacts.small", "Weinig impact (workaround beschikbaar)")}</MenuItem>
          <MenuItem value="2">{t("general.bugs.fields.impacts.much", "Veel impact (geen workaround, maar ik kan verder)")}</MenuItem>
          <MenuItem value="3">{t("general.bugs.fields.impacts.breaking", "Brekend (ik kan niet verder)")}</MenuItem>
        </Select>}
      </Grid>
      <Grid item xs={12}>
        <TextInput
          id="title"
          caption={t("general.bugs.fields.title")}
          starred
          backend
          value={mainObject.title || ''}
          onChange={(e) => {
            setMainObject({
              ...mainObject,
              title: e
            });
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography sx={{fontSize: '0.8rem'}}>{t("general.bugs.fields.content")}:</Typography>
        <Editor
          advanced
          label=""
          value={mainObject.content || ''}
          onChange={(e) => {
            setMainObject({
              ...mainObject,
              content: e
            });
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <FileUpload
          caption={t("general.bugs.fields.item")}
          fileInputName='item'
          selected={mainObject.item}
          onChange={(f) => {
            setMainObject({
              ...mainObject,
              item: f as File
            });
          }}
        />
        {!!mainObject.item_file_name && <Button
          label={mainObject.item_file_name}
          id='download'
          text
          startIcon={<CloudDownloadIcon />}
          onClick={(v) => {
            window.open(mainObject?.get_item, "BLANK");
          }}
        />}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5">{t("general.bugs.section.admin")}</Typography>
        <Divider />
      </Grid>
      <Grid item xs={12} md={4}>
        <Select
          fullWidth
          caption={t("general.bugs.fields.status")}
          backend
          displayEmpty
          id="status"
          value={mainObject.status?.toString() || '0'}
          setValue={(v) => {
            setMainObject({
              ...mainObject,
              status: !!v ? parseInt(v.toString(), 10) : undefined
            });
          }}
        >
          <MenuItem value="0">{t("general.bugs.fields.statusses.open", "Open")}</MenuItem>
          <MenuItem value="1">{t("general.bugs.fields.statusses.pending", "Pending")}</MenuItem>
          <MenuItem value="2">{t("general.bugs.fields.statusses.waiting", "Waiting")}</MenuItem>
          <MenuItem value="3">{t("general.bugs.fields.statusses.closed", "Closed")}</MenuItem>
          <MenuItem value="4">{t("general.bugs.fields.statusses.wishlist", "Wishlist")}</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={12} md={4}>
        <Select
          fullWidth
          caption={t("general.bugs.fields.assigned_to")}
          backend
          displayEmpty
          id="user_id"
          value={mainObject.user_id?.toString() || '0'}
          setValue={(v) => {
            setMainObject({
              ...mainObject,
              user_id: !!v ? parseInt(v.toString(), 10) : undefined
            });
          }}
        >
          <MenuItem value="0">Andere</MenuItem>
          <MenuItem value="9019">Ingrid</MenuItem>
          <MenuItem value="79">Frank</MenuItem>
          <MenuItem value="1">Nico</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5">{t("general.bugs.section.internal")}</Typography>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Typography sx={{fontSize: '0.8rem'}}>{t("general.bugs.fields.internal_comment")}:</Typography>
        <Editor
          advanced
          label=""
          value={mainObject.internal_comment || ''}
          onChange={(e) => {
            setMainObject({
              ...mainObject,
              internal_comment: e
            });
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput
          id="title"
          caption={t("general.bugs.fields.search_terms")}
          multiline
          backend
          value={mainObject.search_terms || ''}
          onChange={(e) => {
            setMainObject({
              ...mainObject,
              search_terms: e
            });
          }}
        />
      </Grid>


      



      <Grid item xs={12} sx={{
        alignContent: 'baseline',
        textAlign: 'center',
        position: {
              xs: 'relative',
              md: 'sticky'
            },
        bottom: '-24px',
        backgroundColor: 'white',
        zIndex: 1201
      }}>
        <Divider sx={{marginTop: 1, marginBottom: 0}} />

        {!!mutationSave.isPending && <CircularProgress />}
        {!mutationSave.isPending && <Button
          label={t("shared.buttons.save")}
          id='save'
          disabled={!mainObject.title}
          contained
          onClick={(v) => {
            let formData = new FormData();
            formData.append('object', 'bug');
            formData.append('handler_id', (login?.id || "").toString());
            formData.append('fields[]', 'id');
            if (!!mainObject?.id) formData.append('ob[id]', mainObject?.id.toString());
            if (!!mainObject?.id) formData.append('id', mainObject?.id.toString());
            // mainObject
            formData.append('ob[title]', mainObject?.title || '');
            formData.append('ob[content]', mainObject?.content || '');
            formData.append('ob[internal_comment]', mainObject?.internal_comment || '');
            formData.append('ob[search_terms]', mainObject?.search_terms || '');
            formData.append('ob[bug_type]', mainObject?.bug_type?.toString() || '');
            formData.append('ob[impact]', mainObject?.impact?.toString() || '');
            formData.append('ob[internal_impact]', mainObject?.internal_impact?.toString() || '');
            formData.append('ob[practice_id]', mainObject?.practice_id?.toString() || '');
            formData.append('ob[owner_id]', mainObject?.owner_id?.toString() || '');
            formData.append('ob[user_id]', mainObject?.user_id?.toString() || '');
            formData.append('ob[status]', mainObject?.status?.toString() || '');
            if (!!mainObject?.item) formData.append(`ob[item]`, mainObject?.item);

            mutationSave.mutate({
              formData: formData
            });
          }}
          sx={{marginBottom: 1, marginTop: 1}}
        />}
        {!mutationSave.isPending && <Button
          label={t("shared.buttons.save_keep_open")}
          id='save'
          disabled={!mainObject.title}
          contained
          onClick={(v) => {
            let formData = new FormData();
            formData.append('object', 'bug');
            formData.append('handler_id', (login?.id || "").toString());
            formData.append('fields[]', 'id');
            if (!!mainObject?.id) formData.append('ob[id]', mainObject?.id.toString());
            if (!!mainObject?.id) formData.append('id', mainObject?.id.toString());
            // mainObject
            formData.append('ob[title]', mainObject?.title || '');
            formData.append('ob[content]', mainObject?.content || '');
            formData.append('ob[internal_comment]', mainObject?.internal_comment || '');
            formData.append('ob[search_terms]', mainObject?.search_terms || '');
            formData.append('ob[bug_type]', mainObject?.bug_type?.toString() || '');
            formData.append('ob[impact]', mainObject?.impact?.toString() || '');
            formData.append('ob[internal_impact]', mainObject?.internal_impact?.toString() || '');
            formData.append('ob[practice_id]', mainObject?.practice_id?.toString() || '');
            formData.append('ob[owner_id]', mainObject?.owner_id?.toString() || '');
            formData.append('ob[user_id]', mainObject?.user_id?.toString() || '');
            formData.append('ob[status]', mainObject?.status?.toString() || '');
            if (!!mainObject?.item) formData.append(`ob[item]`, mainObject?.item);

            mutationSave.mutate({
              formData: formData,
              keepOpen: true
            });
          }}
          sx={{marginBottom: 1, marginTop: 1, marginLeft: 1}}
        />}
        {!mutationSave.isPending && <Button
          label={t("shared.buttons.cancel")}
          id='cancel'
          text
          // contained
          onClick={(v) => {
            navigate("/bugs");
          }}
          sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
        />}
      </Grid>


      {!!mainObject?.id && <>
        <Grid item xs={12} sx={{marginTop: 5}}>
          <Paper sx={{padding: 2}}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography variant="h5">{t("general.bugs.section.actions")}</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                {!flickerEditor && <Editor
                  advanced
                  label={t("general.bugs.fields.message")}
                  value={msg || ''}
                  onChange={(e) => {
                    setMsg(e);
                  }}
                />}
              </Grid>
              {!checkEqual(mainObject, copiedMainObject) && <Typography variant="caption" sx={{color: 'red', fontStyle: 'italic'}}>{t("general.bugs.unsaved_changes")}</Typography>}
              <Grid item xs={12} sx={{marginBottom: 3}}>
                <Button
                  label={t("general.bugs.send_message")}
                  id='save'
                  disabled={!msg}
                  contained
                  onClick={(v) => {
                    setFlickerEditor(true);
                    mutationCustomAction.mutate({
                      formData: {
                        object: 'bug',
                        class_action: 'custom_api_send_message',
                        id: mainObject.id,
                        message: msg
                      }
                    });
                  }}
                  sx={{marginBottom: 1, marginTop: 1}}
                />
              </Grid>
              {(mainObject.extra_data?.chat || []).length === 0 && <Grid item xs={12}>
                <Typography sx={{fontStyle: 'italic', color: 'lightgrey', textAlign: 'center'}}>No messages here...</Typography>
              </Grid>}
              {[...(mainObject.extra_data?.chat || [])].reverse().map(msg => <Grid item xs={12} sx={{
                marginBottom: 2,
                ...([1, 3, 4, 9019].indexOf(msg.user_id) > -1 ? {
                  textAlign: 'right'
                } : {})
              }}>
                <Typography>{msg.user_name} @ {msg.time}</Typography>
                <Divider />
                <Box sx={{
                  padding: 1,
                  border: '1px solid transparent',
                  borderColor: theme.palette.primary.main,
                  display: 'inline-block',
                  marginTop: 0.5,
                  paddingLeft: 2,
                  paddingRight: 2,
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  ...([1, 3, 4, 9019].indexOf(msg.user_id) > -1 ? {
                    borderRadius: "8px 0px 8px 8px",
                  } : {
                    borderRadius: "0px 8px 8px 8px",
                  }),
                  "& p": {
                    marginTop: 0,
                    marginBottom: 0
                  }
                }}>
                  <Typography html sx={{"img": { maxWidth: '100%', maxHeight: '300px' }}}>{msg.message}</Typography>
                  {!!msg.ticket_link && <Button
                    label="ga naar"
                    id='save'
                    startIcon={<ShortcutIcon />}
                    size='small'
                    onClick={(v) => {
                      navigate(`/bug/${msg.ticket_link}`);
                    }}
                    sx={{marginBottom: 0, marginTop: 1}}
                  />}
                </Box>
              </Grid>)}
            </Grid>
          </Paper>
        </Grid>
      </>}
    </Grid>
    
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Page>;
}
